import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { TabContent, TabList, TabRoot, TabTrigger } from '../../../web/components-v2/Tabs';
import { ViewType } from '../../components/LeaderboardComponents/types';
import { useQueryParameter } from '../../hooks/query';
import { BasicPage } from '../BasicPage';
import { Demos } from './components/Demos';
import { Leaderboard } from './components/Leaderboard';
import { Prizes } from './components/Prizes';
import { styleSheet } from './styles';

const isViewType = (value: string): value is ViewType => Object.values<string>(ViewType).includes(value);

const LeaderboardContainerBase: React.FC = () => {
	const [, view, setView] = useQueryParameter<ViewType>('view', ViewType.Leaderboard);
	const userSession = useUserSession();
	const achievementsEnabled = !!userSession.account?.features?.aida?.achievementsEnabled;
	const selectedView = view === ViewType.Prizes && !achievementsEnabled ? ViewType.Leaderboard : view;

	const handleViewChange = (next: string) => {
		if (isViewType(next)) {
			setView(next);
		}
	};

	return (
		<BasicPage appearance='light' title='Leaderboard'>
			<TabRoot value={selectedView} onValueChange={handleViewChange}>
				<TabList>
					<TabTrigger value={ViewType.Leaderboard}>{achievementsEnabled ? 'Leaders' : 'Leaderboard'}</TabTrigger>
					<TabTrigger value={ViewType.Demos}>Demos</TabTrigger>
					{achievementsEnabled ? <TabTrigger value={ViewType.Prizes}>Prizes</TabTrigger> : null}
				</TabList>
				<TabContent value={ViewType.Leaderboard} className={css(styleSheet.tabContent)}>
					<Leaderboard />
				</TabContent>
				<TabContent value={ViewType.Demos} className={css(styleSheet.tabContent)}>
					<Demos />
				</TabContent>
				{achievementsEnabled ? (
					<TabContent value={ViewType.Prizes} className={css(styleSheet.tabContent)}>
						<Prizes />
					</TabContent>
				) : null}
			</TabRoot>
		</BasicPage>
	);
};

export const LeaderboardContainer = observer(LeaderboardContainerBase);
